import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@app/_services";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { UserService } from "@app/user/user.service";
import { constants, errorMessages } from "@assets/data/constants";
import { SharedUtilService } from "@app/_shared/shared-util.service";
import { ExtractorParams, Role } from "@app/_models";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ExtractorInfoDialogComponent } from "@app/_shared/extractor-info-dialog/extractor-info-dialog.component";
import { TestCaseService } from "@app/testcase/testcase.service";
import { CloneAcrossTestcaseComponent } from "../clone-across-testcase/clone-across-testcase.component";

@Component({
  selector: 'app-validation-table',
  templateUrl: './validation-table.component.html',
  styleUrls: ['./validation-table.component.less']
})
export class ValidationTableComponent implements OnInit{
  selectedId: any;
  validations = [];
  readTestCase: any;
  setDeleteAll = false;
  @Input() testCaseDetails: any;
  @Input() endpointDetails: any;
  allEndPoints: any;
  readTestCaseEndPoint: any;
  isAllValidationsSelected = false;
  schemaValidation = [];
  isFilter = false;
  schemaFilter = false;
  projectFiles: any;
  originalExtractor: any;
  expectedExtractor: any;
  validationMetaData: any;
  tctestDataSequence: any[];
  validationForm: FormGroup;
  validationCategories: any;
  expectedExtEndPoints: any;
  validationTypeOptions = [];
  testCaseValidation: any = {};
  isValidationEditable = false;
  endpointTestDataSequence: any;
  filteredTestCaseEndPoints: any;
  validationNewCollapsed = false;
  extractorListForValidation: any = [];
  expectedExtractedExtractorListForValidation: any = [];
  projectWebAutomationTool:any;
  /* Response Extractor */
  responseExtractorAlert = true;
  respBodyFormatterObject = {};
  respHeaderFormatterObject = {};
  @Input() fromParent: any;

  newJsExtractor: any;
  jsFuncExtractor: any = [];
  showJsExpressionForm = false;
  codeMirrorOptions: any = {
    theme: "idea",
    mode: "application/ld+json",
    lineNumbers: true,
    lineWrapping: true,
    foldGutter: true,
    autoCloseBrackets: true,
    matchBrackets: true,
    lint: true,
    gutters: ["CodeMirror-lint-markers"],
  };

  onActiveChangeTriggered = false;

  readonly ADMIN = Role[0].role;
  readonly DEVELOPER = Role[1].role;
  readonly TESTER = Role[2].role;
  readonly VIEWER = Role[3].role;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private testCaseService: TestCaseService,
    private toastr: ToastrService,
    private userService: UserService,
    private sharedUtilService: SharedUtilService,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.route.params.subscribe(() => {
      this.readTestCase = Object.assign({}, this.testCaseDetails);
      this.authService.getUserRoleByProject(this.testCaseDetails.role); /* Role */
      this.validationMetaData = JSON.parse(localStorage.getItem("about")).validationMetadata;
      this.validationCategories = Object.assign(this.validationMetaData.categories);
      this.getAssociatedEndpoints().catch((errMsg) => {
        this.toastr.error(errorMessages.fetchAsstdEPError + errMsg);
      });
      this.getAssociatedEndpoints().then(async (data:any) => {
        const selevtedEndpoint = data.find((obj) => obj.sequenceNumber === this.endpointDetails.testCaseEndPointSequence);
     await this.validationForm.patchValue({
        testCaseEndPoint: selevtedEndpoint,
     });
       await this.changedTCEP(selevtedEndpoint, true)
        await this.validationForm.patchValue({
          actual: this.endpointDetails,
        });
      });
      this.getProjectUploadedFiles();
      this.getValidations();
      this.getTestdataSequence();
      this.createNewValidation();
      const promiseRespExtractors = this.getResponseExtractorsOfEndpoint();
      promiseRespExtractors.then((respExt) => {
        this.originalExtractor = respExt;
      });
    });  
   
  }
  closeModal() {
    this.activeModal.close();
  }
  /* get all the associated endpoints for testcase */
  getAssociatedEndpoints() {
    return new Promise((resolve, reject) => {
      this.testCaseService.getShortData(this.readTestCase.id).subscribe((epdata) => {
        if (epdata.code === 200) {
          this.readTestCase.testCaseEndPoints = epdata.response;
          this.expectedExtEndPoints = Object.assign(this.readTestCase.testCaseEndPoints);
          this.filteredTestCaseEndPoints = Object.assign(this.readTestCase.testCaseEndPoints);
          this.schemaFilter = epdata.response.some(endpoint => endpoint.endPointType === 'REST');
          resolve(epdata.response);
        } else if (epdata.code === 204) {
          this.readTestCase.testCaseEndPoints = epdata.response;
          resolve(epdata.response);
        } else {
          reject(epdata.message);
        }
      });
    });
  }
  projectConfigWebTool(projectWebAutomationTool) {
    this.projectWebAutomationTool = projectWebAutomationTool;
    if (projectWebAutomationTool === 'PLAYWRIGHT' && this.validationMetaData && this.validationMetaData.playwrightCategories) {
      this.validationCategories = JSON.parse(localStorage.getItem("about")).validationMetadata.playwrightCategories;
      this.validationMetaData.categories = JSON.parse(localStorage.getItem("about")).validationMetadata.playwrightCategories;
      this.validationMetaData.actions = JSON.parse(localStorage.getItem("about")).validationMetadata.playwrightActions;
    } else {
      this.validationCategories = JSON.parse(localStorage.getItem("about")).validationMetadata.categories;
      this.validationMetaData = JSON.parse(localStorage.getItem("about")).validationMetadata;}
}
  getTestdataSequence() {
    this.testCaseService.getTestDataByTestCase(this.testCaseDetails.id).subscribe((data) => {
      this.tctestDataSequence = [];
      let found = false;
      this.allEndPoints = data.response;
      if (data.code === 200) {
        data.response.forEach((testDataSet) => {
          if (!found && testDataSet.testCaseEndPointDataSets.length > 0) {
            testDataSet.testCaseEndPointDataSets.forEach((testDataEP) => {
              if (testDataEP.sequence === 0) {
                this.tctestDataSequence.push(constants.testDataPrimary);
              } else {
                this.tctestDataSequence.push(constants.testDataSecondary + testDataEP.sequence);
              }
              found = true;
            });
          }
        });
      }
    });
  }

  getProjectUploadedFiles() {
    this.userService.getFilesUploadedForProject(this.readTestCase.project.id).subscribe((data) => {
      if (data.code === 200) {
        this.projectFiles = data.response;
      }
    });
  }

  getValidations() {
    this.testCaseService.getValidationByTestcaseId(this.testCaseDetails.id).subscribe((data) => {
      if (data.code === 200) {
        this.validations = data.response;
        this.validations.forEach((validation) => {
          if (null != validation.testDataSequence) {
            if (validation.testDataSequence > 0) {
              validation.testDataSequence = constants.testDataSecondary + validation.testDataSequence;
            } else {
              validation.testDataSequence = constants.testDataPrimary;
            }
          }
        });
        this.schemaValidation = [...this.validations];
        this.onCheckboxChange(this.isFilter);
      } else {
        this.validations = [];
      }
    });
  }

  initiateValidationForm() {
    this.validationForm = new FormGroup({
      id: new FormControl(),
      sequence: new FormControl(),
      name: new FormControl(""),
      active: new FormControl(true),
      testCaseEndPoint: new FormControl(),
      testDataSequence: new FormControl(""),
      validationType: new FormControl(),
      actual: new FormControl(this.endpointDetails.displayValue),
      actualIterable: new FormControl(),
      actualIterableValue: new FormControl(),
      iterableConditionAndOr: new FormControl("AND"),
      condition: new FormControl(),
      expected: new FormControl({}),
      expectedExtractor: new FormControl(),
      threshold: new FormControl(0),
      tempActionPass: new FormControl({}),
      tempActionFail: new FormControl({}),
      markAsFailed: new FormControl(true),
      caseSensitive: new FormControl(true),
    });

    this.validationForm.controls.testCaseEndPoint.setValidators(Validators.required);
    this.validationForm.controls.validationType.setValidators(Validators.required);
    this.validationForm.controls.actual.setValidators(Validators.required);
    this.validationForm.controls.condition.setValidators(Validators.required);

    this.testCaseValidation = this.validationForm.value;
  }

  createNewValidation() {
    this.isValidationEditable = false;
    this.initiateValidationForm();
    // this.testCaseValidation.postValidationActions = [];
  }

  toogleAllValidations() {
    this.isAllValidationsSelected = !this.isAllValidationsSelected;
    this.setDeleteAll = this.isAllValidationsSelected;
    this.validations.forEach((validation) => {
      validation.selected = this.isAllValidationsSelected;
    });
  }

  optionToggledValidaton(index: string | number) {
    this.validations[index].selected = !this.validations[index].selected;
    this.setDeleteAll = false;
    let count = 0;
    this.validations.forEach((validation) => {
      if (validation.selected) {
        this.setDeleteAll = true;
        count++;
      }
    });
    if (count === this.validations.length) {
      this.isAllValidationsSelected = true;
    } else {
      this.isAllValidationsSelected = false;
    }
  }

  editValidation(validation: any) {
    this.validationNewCollapsed = true;
    this.isValidationEditable = true;
    let updatedValidation = Object.assign({}, validation);
    this.testCaseValidation = Object.assign({}, validation);

    /* set validation type */
    this.validationMetaData.categories.forEach((category) => {
      category.options.forEach((opt) => {
        if (opt.name === updatedValidation.condition) {
          this.testCaseValidation.validationType = category;
          this.testCaseValidation.condition = opt;
        }
      });
    });

    /* set the postvalidaiton proper */
    updatedValidation.postValidationActions?.forEach((action: any) => {
      if (action.onResult === constants.passed) {
        this.testCaseValidation.tempActionPass = {};
        this.testCaseValidation.tempActionPass.postAction = true;
        this.testCaseValidation.tempActionPass.action = action.action;
        this.testCaseValidation.tempActionPass.onResult = action.onResult;
        this.testCaseValidation.tempActionPass.testCaseEndPoint = action.testCaseEndPoint;
        this.testCaseValidation.tempActionPass.retryConfig = action.retryConfig;
      } else if (action.onResult === constants.failed) {
        this.testCaseValidation.tempActionFail = {};
        this.testCaseValidation.tempActionFail.postAction = true;
        this.testCaseValidation.tempActionFail.action = action.action;
        this.testCaseValidation.tempActionFail.onResult = action.onResult;
        this.testCaseValidation.tempActionFail.testCaseEndPoint = action.testCaseEndPoint;
        this.testCaseValidation.tempActionFail.retryConfig = action.retryConfig;
      }
    });

    this.readTestCase.respExtractorTCEPs.forEach((object: any) => {
      object.responseExtractors.forEach((respExt: any) => {
        if (this.testCaseValidation.expected.responseExtractor && this.testCaseValidation.expected.responseExtractor !== undefined) {
          if (respExt.id === this.testCaseValidation.expected.responseExtractor.id) {
            this.expectedExtractor = object;
          }
        }
      });
    });

    updatedValidation = Object.assign({}, this.testCaseValidation);
    updatedValidation.testCaseEndPoint = this.readTestCase.testCaseEndPoints.filter(
      (ep) => ep.id === updatedValidation.testCaseEndPoint.id
    )[0];

    this.validationForm.patchValue({
      id: updatedValidation.id,
      sequence: updatedValidation.sequence,
      name: updatedValidation.name,
      active: updatedValidation.active,
      testCaseEndPoint: updatedValidation.testCaseEndPoint,
      testDataSequence: updatedValidation.testDataSequence ? updatedValidation.testDataSequence : "",
      validationType: updatedValidation.validationType,
      actual: updatedValidation.actual,
      actualIterable: updatedValidation.actualIterable,
      actualIterableValue: updatedValidation.actualIterableValue,
      iterableConditionAndOr: updatedValidation.iterableConditionAndOr,
      condition: updatedValidation.condition,
      expected: updatedValidation.expected,
      threshold: updatedValidation.threshold,
      expectedExtractor: this.expectedExtractor,
      tempActionPass: updatedValidation.tempActionPass ? updatedValidation.tempActionPass : {},
      tempActionFail: updatedValidation.tempActionFail ? updatedValidation.tempActionFail : {},
      markAsFailed: updatedValidation.markAsFailed,
      caseSensitive: updatedValidation.caseSensitive,
    });

    this.changedTCEP(updatedValidation.testCaseEndPoint);
    window.scroll(0, 0);
  }

  cloneValidation(validation: any) {
    const validationCloned = Object.assign({}, validation);
    if (validationCloned.testDataSequence) {
      if (validationCloned.testDataSequence === constants.testDataPrimary) {
        validationCloned.testDataSequence = 0;
      } else {
        validationCloned.testDataSequence = validationCloned.testDataSequence.split(" ")[1];
      }
    }

    if (validationCloned.selected) {
      delete validationCloned.selected;
    }

    this.testCaseService.cloneValidation(validationCloned).subscribe((data) => {
      if (data.code === 200) {
        this.getValidations();
        this.toastr.success(data.message);
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  addValidations(validation: any, saveType: string) {
    const newValidation = Object.assign({}, validation);
    let endpointCount = 0;
    let obj: any;
    const isPassValid = newValidation.tempActionPass;
    const isFailValid = newValidation.tempActionFail;

    if (isPassValid.postAction && isPassValid.action === "RETRY" &&
      (isPassValid.retryConfig?.maxRetry < 0 || isPassValid.retryConfig?.maxRetry > 99 || isPassValid.retryConfig?.maxRetry == undefined)) {
      this.toastr.error("Action on pass retry value should be between 0 and 99.");
      return;
    }

    if (isFailValid.postAction && isFailValid.action === "RETRY" &&
      (isFailValid.retryConfig?.maxRetry < 0 || isFailValid.retryConfig?.maxRetry > 99 || isFailValid.retryConfig?.maxRetry == undefined)) {
      this.toastr.error("Action on fail retry value should be between 0 and 99.");
      return;
    }

    if (this.testCaseValidation.postValidationActions === undefined) {
      newValidation.postValidationActions = [];
    } else {
      newValidation.postValidationActions = this.testCaseValidation.postValidationActions;
    }

    /* Passed Section */
    if ((newValidation.tempActionPass !== undefined || newValidation.tempActionPass !== {}) && newValidation.tempActionPass.postAction) {
      obj = {};
      if (newValidation.tempActionPass.action === constants.postValidationJump) {
        obj = {
          action: newValidation.tempActionPass.action,
          onResult: constants.passed,
          testCaseEndPoint: newValidation.tempActionPass.testCaseEndPoint,
        };
        newValidation.postValidationActions?.forEach((action, index) => {
          if (action.action === obj.action && action.onResult === obj.onResult) {
            newValidation.postValidationActions?.splice(index, 1);
          }
        });
        newValidation.postValidationActions?.push(obj);
      } else if (newValidation.tempActionPass.action === constants.postValidationExit) {
        obj = {
          action: newValidation.tempActionPass.action,
          onResult: constants.passed,
        };
        newValidation.postValidationActions?.forEach((action: any, index: any) => {
          if (action.action === obj.action && action.onResult === obj.onResult) {
            newValidation.postValidationActions?.splice(index, 1);
          }
        });
        newValidation.postValidationActions?.push(obj);
      } else if (newValidation.tempActionPass.action === constants.postValidationRetry) {
        obj = {
          action: newValidation.tempActionPass.action,
          onResult: constants.passed,
        };
        newValidation.postValidationActions?.forEach((action, index) => {
          if (action.action === obj.action && action.onResult === obj.onResult) {
            newValidation.postValidationActions?.splice(index, 1);
          }
        });
        obj.retryConfig = this.tempActionPassValue.retryConfig;
        newValidation.postValidationActions?.push(obj);
      }
    }

    /* Failed section */
    if ((newValidation.tempActionFail !== undefined || newValidation.tempActionFail !== {}) && newValidation.tempActionFail.postAction) {
      if (newValidation.tempActionFail.action === constants.postValidationJump) {
        obj = {
          action: newValidation.tempActionFail.action,
          onResult: constants.failed,
          testCaseEndPoint: newValidation.tempActionFail.testCaseEndPoint,
        };
        newValidation.postValidationActions?.forEach((action, index) => {
          if (action.action === obj.action && action.onResult === obj.onResult) {
            newValidation.postValidationActions?.splice(index, 1);
          }
        });
        newValidation.postValidationActions?.push(obj);
      } else if (newValidation.tempActionFail.action === constants.postValidationExit) {
        obj = {
          action: newValidation.tempActionFail.action,
          onResult: constants.failed,
        };
        newValidation.postValidationActions?.forEach((action, index) => {
          if (action.action === obj.action && action.onResult === obj.onResult) {
            newValidation.postValidationActions?.splice(index, 1);
          }
        });
        newValidation.postValidationActions?.push(obj);
      } else if (newValidation.tempActionFail.action === constants.postValidationRetry) {
        obj = {
          action: newValidation.tempActionFail.action,
          onResult: constants.failed,
        };
        newValidation.postValidationActions?.forEach((action, index) => {
          if (action.action === obj.action && action.onResult === obj.onResult) {
            newValidation.postValidationActions?.splice(index, 1);
          }
        });
        obj.retryConfig = this.tempActionFailValue.retryConfig;
        newValidation.postValidationActions?.push(obj);
      }
    }

    if (newValidation.postValidationActions?.length > 0) {
      newValidation.postValidationActions?.forEach((action) => {
        if (action.testCaseEndPoint && action.testCaseEndPoint !== undefined) {
          delete action.testCaseEndPoint.webEndPoint;
          delete action.testCaseEndPoint.soapEndPoint;
          delete action.testCaseEndPoint.restEndPoint;
        }
      });
    }

    if (newValidation.actual.extractorType === "FILE") {
      newValidation.expected.isFile = true;
    }

    if (newValidation.validationType.name !== "SIMPLE") {
      if (newValidation.expected.isFile && newValidation.expected.fileInfo == null) {
        this.toastr.error("Please select a file");
        return false;
      } else if (newValidation.expected.isExtracted && newValidation.expected.responseExtractor == null) {
        this.toastr.error("Response extractor is required");
        return false;
      } else if (
        !newValidation.expected.isFile &&
        !newValidation.expected.isExtracted &&
        (newValidation.expected.value == null || newValidation.expected.value == "")
      ) {
        this.toastr.error("Expected is required");
        return false;
      } else if (
        newValidation.expected.isExtracted &&
        newValidation.expected.expectedIterable &&
        newValidation.expected.expectedIterableValue === null
      ) {
        this.toastr.error("Iterable value is required");
        return false;
      }
    }

    /* remove the not required fields */
    delete newValidation.validationType;
    delete newValidation.tempActionFail;
    delete newValidation.tempActionPass;
    delete newValidation.expectedExtractor;
    if (newValidation.testCaseEndPoint.endPoint !== undefined) {
      delete newValidation.testCaseEndPoint.endPoint;
    }
    if (newValidation.testCaseEndPoint.testCaseResponseExtractor !== undefined) {
      delete newValidation.testCaseEndPoint.testCaseResponseExtractor;
    }
    if (newValidation.testCaseEndPoint.envExistsForEP !== undefined) {
      delete newValidation.testCaseEndPoint.envExistsForEP;
    }
    if (newValidation.testCaseEndPoint.webEndPoint !== undefined) {
      delete newValidation.testCaseEndPoint.webEndPoint;
    }
    if (newValidation.testCaseEndPoint.soapEndPoint !== undefined) {
      delete newValidation.testCaseEndPoint.soapEndPoint;
    }
    if (newValidation.testCaseEndPoint.restEndPoint !== undefined) {
      delete newValidation.testCaseEndPoint.restEndPoint;
    }
    /* Delete the endpoint name from actual */
    if (newValidation.actual.endpointName !== undefined) {
      delete newValidation.actual.endpointName;
    }

    /* Delete the endpoint name from expected */
    if (newValidation.expected.responseExtractor !== undefined && newValidation.expected.responseExtractor != null) {
      if (newValidation.expected.responseExtractor.endpointName !== undefined) {
        delete newValidation.expected.responseExtractor.endpointName;
      }
    }

    /* Remove Not Required Post-Validation actions */
    if (!this.tempActionPassValue.postAction) {
      newValidation.postValidationActions = newValidation.postValidationActions?.filter((action) => action.onResult !== constants.passed);
    }
    if (!this.tempActionFailValue.postAction) {
      newValidation.postValidationActions = newValidation.postValidationActions?.filter((action) => action.onResult !== constants.failed);
    }

    /* Check for errors */
    if (newValidation.condition.name === undefined) {
      this.toastr.error(errorMessages.selectCondition);
      return false;
    }
    if (newValidation.postValidationActions !== undefined) {
      newValidation.postValidationActions?.forEach((action) => {
        if (action.testCaseEndPoint !== undefined && action.testCaseEndPoint != null) {
          if (action.testCaseEndPoint.envExistsForEP !== undefined) {
            delete action.testCaseEndPoint.envExistsForEP;
          }
          if (action.testCaseEndPoint.endPoint !== undefined) {
            delete action.testCaseEndPoint.endPoint;
          }
        }
      });
    }

    newValidation.condition = newValidation.condition.name;
    if (newValidation.testDataSequence) {
      if (newValidation.testDataSequence === constants.testDataPrimary) {
        newValidation.testDataSequence = 0;
      } else {
        newValidation.testDataSequence = newValidation.testDataSequence.split(" ")[1];
      }
    }

    if (saveType === "save") {
      let sequence = 0;
      if (this.validations != null && this.validations.length > 0) {
        sequence = this.validations.length;
      }
      newValidation.sequence = sequence;
      this.testCaseService.createValidation(newValidation).subscribe((data) => {
        if (data.code === 200) {
          this.getValidations();
          this.testCaseValidation = {};
          this.validationForm.reset();
          this.validationNewCollapsed = false;
          this.toastr.success(data.message);
        } else {
          this.toastr.error(data.message);
        }
      });
    } else if (saveType === "update") {
      this.testCaseService.updateValidation(newValidation).subscribe((data) => {
        if (data.code === 200) {
          this.getValidations();
          this.testCaseValidation = {};
          this.validationForm.reset();
          this.validationNewCollapsed = false;
          this.isValidationEditable = false;
          this.toastr.success(data.message);
        } else {
          this.toastr.error(data.message);
        }
      });
    }
    endpointCount = 0;
    this.activeModal.close();
  }

  deleteMultipleValidations(validations: any[]) {
    const confirmMessage = constants.deleteMultipleValidation;

    this.sharedUtilService.openConfirmDialog(confirmMessage, false).then((result) => {
      if (result) {
        const deletedValidations = validations.filter((validation) => validation.selected).map((validation) => ({ id: validation.id }));

        this.testCaseService.deleteMultipleValidations(deletedValidations).subscribe((data) => {
          if (data.code === 200) {
            this.toastr.success(data.message);
            this.getValidations();
            this.isAllValidationsSelected = false;
            this.setDeleteAll = false;
          } else {
            this.toastr.error(data.message);
          }
        });
      }
    });
  }

  changedTCEP(extractedTCEP, actualRefresh?: boolean) {
    if(!this.validationForm.get('id').value){
    this.validationForm.get("validationType").reset();
    }
    if (!extractedTCEP) {
      return;
    }
    if (actualRefresh) {
      this.validationForm.get("actual").reset();
    }
    // Filter other lists
    this.filterFileType(extractedTCEP.responseType);
    this.filterFileCondition(this.validationTypeValue, extractedTCEP.responseType);
    this.getExpectedEndpointsValidation(extractedTCEP);
    this.setSkipJump(extractedTCEP.sequenceNumber);
    this.getlistOfExtractorForValidation(extractedTCEP);
    this.getlistOExpectedExtractedExtractorForValidation(this.expectedExtractor);
    this.showTCEPInDetail(extractedTCEP);
    if (this.readTestCase.project.q2c) {
      this.getTestDataByTestcaseEndpoint(extractedTCEP.id);
    }
  }

  showTCEPInDetail(testCaseEndPoint, selectedIndex?: number) {
    this.selectedId = selectedIndex || 0;
    if (testCaseEndPoint === undefined) {
      return false;
    }
    if (testCaseEndPoint.id == null) {
      testCaseEndPoint.id = testCaseEndPoint.testCaseEndPointId;
    }

    this.testCaseService.getParticularExecution(testCaseEndPoint.endPointId, testCaseEndPoint.id).subscribe((data) => {
      if (data.code === 200) {
        this.readTestCaseEndPoint = testCaseEndPoint;
        this.readTestCaseEndPoint.endPoint = data.response;
        if (data.response.endPointExecution) {
          this.readTestCaseEndPoint.endPoint.testCaseResponseExtractorTemp = [];
          /* Read from server  setting the responseextractor */
          const extractorsPromise = this.getResponseExtractorsOfEndpoint();
          extractorsPromise
            .then((respExt) => {
              this.setResponseExtractor(respExt);
            })
            .catch((errMsg) => this.toastr.error(errorMessages.fetchResponseExtractorError + errMsg));
        } else {
          this.readTestCaseEndPoint = testCaseEndPoint;
          this.readTestCaseEndPoint.endPoint = null;
        }
      }
    });
  }

  getTestDataByTestcaseEndpoint(testcaseEndpointId: string) {
    this.endpointTestDataSequence = [];
    this.testCaseService.getTestDataByTestcaseEndpoint(testcaseEndpointId).subscribe((data) => {
      if (data.code === 200) {
        data.response.forEach((item: any) => {
          if (item.sequence === 0) {
            this.endpointTestDataSequence.push(constants.testDataPrimary);
          } else {
            this.endpointTestDataSequence.push(constants.testDataSecondary + item.sequence);
          }
        });
      }
    });
  }

  filterFileType(responseType) {
    if (responseType !== undefined && responseType === constants.file) {
      this.validationCategories = this.validationCategories.filter((category) => category.name === constants.categoryCompare);
    } else {
      if(this.projectWebAutomationTool === 'PLAYWRIGHT'){
        this.validationCategories = Object.assign(this.validationMetaData.playwrightCategories);
      }else{
        this.validationCategories = Object.assign(this.validationMetaData.categories);
      }
    }
  }

  filterFileCondition(validationType: any, responseType: string, changedManually?: boolean) {
    this.validationTypeOptions = [];
    if (changedManually) {
      this.validationForm.get("condition").reset();
    }
    if (validationType) {
      if (
        validationType !== undefined &&
        validationType !== "" &&
        validationType.name === constants.categoryCompare &&
        responseType === constants.file
      ) {
        this.validationTypeOptions = validationType.options.filter(
          (opt: any) => opt.name === constants.optionEqual || opt.name === constants.optionNotEqual
        );
      } else {
        this.validationTypeOptions = validationType.options;
      }
    }
    if (validationType !== null) {
      if (validationType.name === "REGEX" || validationType.name === "SIMPLE") {
        this.expectedValue.isExtracted = false;
      }
    }
  }

  getlistOfExtractorForValidation(endPoint: any, isExpectedExtractor?: any) {
    if (isExpectedExtractor) {
      this.expectedValue.responseExtractor = null;
    }
    if (endPoint !== undefined && endPoint != null) {
      this.extractorListForValidation = [];
      this.originalExtractor.forEach((extractor) => {
        if (extractor.sequenceNumber === endPoint.sequenceNumber) {
          if (extractor.responseExtractors !== undefined) {
            /*Check for 'RESPONSE_CODE' */
            extractor.responseExtractors.forEach((respExt) => {
              if (respExt.responseSource === constants.responseSourceCode) {
                respExt.endpointName = "(" + extractor.endPointName + ")";
              } else {
                respExt.endpointName = "(" + extractor.id + ")";
              }
            });
            this.extractorListForValidation = this.extractorListForValidation.concat(extractor.responseExtractors);
          }
        }
      });
      return this.extractorListForValidation;
    }
  }

  getlistOExpectedExtractedExtractorForValidation(endPoint : any, isExpectedExtractor?: any) {
    if (isExpectedExtractor) {
      this.expectedValue.responseExtractor = null;
    }
    if (endPoint !== undefined && endPoint != null) {
      this.expectedExtractedExtractorListForValidation = [];
      this.originalExtractor.forEach((extractor) => {
        if (extractor.sequenceNumber === endPoint.sequenceNumber) {
          if (extractor.responseExtractors !== undefined) {
            /*Check for 'RESPONSE_CODE' */
            extractor.responseExtractors.forEach((respExt) => {
              if (respExt.responseSource === constants.responseSourceCode) {
                respExt.endpointName = "(" + extractor.endPointName + ")";
              } else {
                respExt.endpointName = "(" + extractor.id + ")";
              }
            });
            this.expectedExtractedExtractorListForValidation = this.expectedExtractedExtractorListForValidation.concat(extractor.responseExtractors);
          }
        }
      });
      return this.expectedExtractedExtractorListForValidation;
    }
  }

  getExpectedEndpointsValidation(testCaseEndPoint: any) {
    if (testCaseEndPoint && testCaseEndPoint !== undefined) {
      this.expectedExtEndPoints = this.readTestCase.testCaseEndPoints.filter(
        (tcEP: any) => testCaseEndPoint.sequenceNumber >= tcEP.sequenceNumber
      );
    }
  }

  removePostAction(status: any, checkBoxType: any, checked: any) {
    if (!checked) {
      this.testCaseValidation[checkBoxType] = {};

      if (this.testCaseValidation.postValidationActions !== undefined && this.testCaseValidation.postValidationActions?.length > 0) {
        this.testCaseValidation.postValidationActions?.forEach((action, index) => {
          if (action.onResult === status) {
            this.testCaseValidation.postValidationActions?.splice(index, 1);
          }
        });
      }
    }
  }

  setFailPassAction(actions, onResult) {
    this.testCaseValidation.postValidationActions?.forEach((action, index) => {
      if (action.action !== actions && action.onResult === onResult) {
        this.testCaseValidation.postValidationActions?.splice(index, 1);
      }
    });

    if (actions === constants.postValidationRetry && onResult === constants.passed) {
      if (this.tempActionPassValue.retryConfig === undefined || this.tempActionPassValue.retryConfig == null) {
        this.tempActionPassValue.retryConfig = {};
      }
    }

    if (actions === constants.postValidationRetry && onResult === constants.failed) {
      if (this.tempActionFailValue.retryConfig === undefined || this.tempActionFailValue.retryConfig == null) {
        this.tempActionFailValue.retryConfig = {};
      }
    }
  }

  setSkipJump(sequenceId) {
    console.log("sequenceId", sequenceId);
    if (sequenceId !== undefined) {
      this.filteredTestCaseEndPoints = this.readTestCase.testCaseEndPoints.filter((tcEP) => tcEP.sequenceNumber > sequenceId);
    }
  }

  setRemovePostValid(objs, testCaseEndPoint, onResult) {
    const obj = {
      action: objs.action,
      onResult,
      testCaseEndPoint,
    };

    if (this.testCaseValidation.postValidationActions !== undefined && this.testCaseValidation.postValidationActions?.length > 0) {
      let index;
      this.testCaseValidation.postValidationActions?.forEach((action, i) => {
        if (action.action === obj.action && action.onResult === obj.onResult && action.testCaseEndPoint.id === obj.testCaseEndPoint.id) {
          index = i;
        }
      });
      if (index > -1) {
        this.testCaseValidation.postValidationActions?.splice(index, 1);
      } else {
        this.testCaseValidation.postValidationActions?.push(obj);
      }
    } else {
      this.testCaseValidation.postValidationActions = [];
      this.testCaseValidation.postValidationActions?.push(obj);
    }
  }

  testcaseEndPointCheckBox(id, requestType) {
    if (this.testCaseValidation.postValidationActions !== undefined && this.testCaseValidation.postValidationActions?.length > 0) {
      if (
        (this.tempActionPassValue !== undefined && this.tempActionPassValue.action === constants.postValidationSkip) ||
        (this.tempActionFailValue !== undefined && this.tempActionFailValue.action === constants.postValidationSkip)
      ) {
        let returnType = false;
        this.testCaseValidation.postValidationActions?.forEach((action) => {
          if (action.action === constants.postValidationSkip) {
            if (action.testCaseEndPoint.id === id && action.onResult === requestType) {
              returnType = true;
            }
          }
        });
        return returnType;
      }
    }
  }

  isExtractedClicked() {
    if (this.expectedValue.isExtracted === undefined) {
      this.expectedValue.isExtracted = false;
    }
    this.expectedValue.isExtracted = !this.expectedValue.isExtracted;
    this.expectedValue.isFile = false;
  }

  isFileClicked() {
    if (this.expectedValue.isFile === undefined) {
      this.expectedValue.isFile = false;
    }
    this.expectedValue.isFile = !this.expectedValue.isFile;
    this.expectedValue.isExtracted = false;
  }

  /* Response Extractor Section */
  addJsonToExtractor(keyValuePair: any, responseType) {
    if (responseType === "responseBody") {
      this.respBodyFormatterObject = {
        responseSource: constants.responseSourceBody,
        displayValue: keyValuePair.key,
        pathToExtract: keyValuePair.value,
      };
      this.readTestCaseEndPoint.endPoint.jsonExtractor = {};
      this.readTestCaseEndPoint.endPoint.jsonExtractor.key = keyValuePair.key;
      this.readTestCaseEndPoint.endPoint.jsonExtractor.value = keyValuePair.value;
    } else if (responseType === "responseHeaders") {
      this.respHeaderFormatterObject = {
        responseSource: constants.responseSourceHeader,
        displayValue: keyValuePair.key,
        pathToExtract: keyValuePair.value.slice(2),
      };
    }
  }

  updateJsonExtractor(extractedParams: ExtractorParams) {
    this.testCaseService.updateSyncRespExtractor(this.readTestCaseEndPoint.id, extractedParams.extractedParams).subscribe((data) => {
      if (data.code === 200) {
        this.readSyncRespExtractor(true);
        this.toastr.success(data.message);
      } else {
        this.toastr.info(data.message);
      }
    });
  }

  readSyncRespExtractor(refresh) {
    if (this.readTestCase.id == null || this.readTestCase.id === "undefined") {
      return;
    }
    if (this.readTestCase.respExtractorTCEPs != null && refresh !== true) {
      return;
    }

    this.testCaseService.readSyncRespExtractor(this.readTestCase.id).subscribe((data) => {
      if (data.code === 200) {
        this.readTestCase.respExtractorTCEPs = data.response;
        this.originalExtractor = Object.assign(this.readTestCase.respExtractorTCEPs);
        this.getlistOfExtractorForValidation(this.readTestCaseEndPoint);
      }
    });
  }

  getResponseExtractorsOfEndpoint(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.testCaseService.readSyncRespExtractor(this.testCaseDetails.id).subscribe((data) => {
        if (data.code === 200) {
      this.readTestCase.respExtractorTCEPs = data.response;
          resolve(data.response);
        } else if (data.code === 204) {
          this.readTestCase.respExtractorTCEPs = data.response;
          resolve(data.response);
        } else {
          reject(data.message);
        }
      });
    });
  }

  setResponseExtractor(responseExtractors) {
    responseExtractors.forEach((respExt) => {
      if (respExt.id === this.readTestCaseEndPoint.id) {
        this.readTestCaseEndPoint.endPoint.testCaseResponseExtractorTemp = Object.assign(respExt.responseExtractors);
      }
    });

    // Extract js function from Extractor
    this.jsFuncExtractor = this.readTestCaseEndPoint.endPoint.testCaseResponseExtractorTemp.filter(
      (extractor) => extractor.extractorType === constants.extratorTypeJSFunc
    );

    this.readTestCaseEndPoint.endPoint.jsonExtractor = {};
    if (this.readTestCaseEndPoint.endPoint.jsonExtractorParams != null) {
      this.readTestCaseEndPoint.endPoint.jsonExtractorParamsTemp = this.readTestCaseEndPoint.endPoint.jsonExtractorParams;
    }
  }

  /* JavaScript Expression Section */
  createJsExpression() {
    this.showJsExpressionForm = true;
    this.newJsExtractor = {
      id: null,
      displayValue: null,
      functionBody: "",
      extractorType: constants.extratorTypeJSFunc,
    };
  }

  addToTemporaryList(jsExtractor: any) {
    if (!jsExtractor) {
      return;
    }

    const newJsExtractor = Object.assign({}, jsExtractor);
    if (newJsExtractor.id) {
      this.jsFuncExtractor.forEach((jsFunc, index) => {
        if (jsFunc.id === newJsExtractor.id) {
          this.jsFuncExtractor[index] = newJsExtractor;
        }
      });
    } else {
      newJsExtractor.extractorType = constants.extratorTypeJSFunc;
      this.jsFuncExtractor.push(newJsExtractor);
    }
    this.cancelJsForm();
  }

  editJsExtractor(jsExtractor) {
    this.showJsExpressionForm = true;
    this.newJsExtractor = Object.assign({}, jsExtractor);
  }

  deleteJsExtractor(jsExtractorIndex) {
    this.jsFuncExtractor.splice(jsExtractorIndex, 1);
  }

  saveJsExtractor(jsFuncExtractors) {
    if (!this.readTestCaseEndPoint) {
      this.toastr.error("Endpoint is not yet executed !");
      return;
    }
    let updatedJsFuncExtractors = Object.assign(jsFuncExtractors);
    updatedJsFuncExtractors = updatedJsFuncExtractors.map((jsFunExt: any) => {
      delete jsFunExt.endpointName;
      return jsFunExt;
    });
    this.testCaseService.updateJsExpressionList(this.readTestCaseEndPoint.id, updatedJsFuncExtractors).subscribe((data) => {
      if (data.code === 200) {
        this.toastr.success(data.message);
        this.testCaseService.readSyncRespExtractor(this.readTestCase.id).subscribe((respExt) => {
          if (respExt.code === 200) {
            this.originalExtractor = Object.assign(respExt.response);
            this.readTestCase.respExtractorTCEPs = Object.assign(respExt.response);
            respExt.response.forEach((resp) => {
              if (resp.endPointId === this.readTestCaseEndPoint.endPointId) {
                /* Set js extractors */
                this.jsFuncExtractor = resp.responseExtractors.filter(
                  (extractor) => extractor.extractorType === constants.extratorTypeJSFunc
                );
                this.getlistOfExtractorForValidation(this.readTestCaseEndPoint);
              }
            });
          }
        });
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  openExtractorInfoDialog() {
    const modalRef = this.modalService.open(
      ExtractorInfoDialogComponent,
      {
        ariaLabelledBy: "modal-basic-title",
        backdrop: true,
        centered: true,
        size: "lg",
      }
    );
  }

  cancelJsForm() {
    this.showJsExpressionForm = false;
    this.newJsExtractor = {
      id: null,
      displayValue: null,
      functionBody: "",
      extractorType: constants.extratorTypeJSFunc,
    };
  }

  deleteValidation(validation:any) {
    const relayConfirmMessage = constants.deleteMessage;
    this.sharedUtilService.openConfirmDialog(relayConfirmMessage, false).then((result) => {
      if (result) {
        this.testCaseService.deleteValidation(validation.id).subscribe(data => {
          if (data.code == 200) {
            this.toastr.success(data.message);
            this.getValidations();
            this.isAllValidationsSelected = false;
            this.setDeleteAll = false;
          } else {
            this.toastr.error(data.message);
          }
        });
      }
    });
  }

  // GETTERs and SETTERs
  get testCaseEndPointValue() {
    return this.validationForm.controls.testCaseEndPoint.value;
  }

  get validationTypeValue() {
    return this.validationForm.controls.validationType.value;
  }

  get conditionValue() {
    return this.validationForm.controls.condition.value;
  }

  get expectedValue() {
    return this.validationForm.controls.expected.value;
  }

  get expectedExtractorValue() {
    return this.validationForm.controls.expectedExtractor.value;
  }

  get tempActionPassValue() {
    return this.validationForm.controls.tempActionPass.value;
  }

  get tempActionFailValue() {
    return this.validationForm.controls.tempActionFail.value;
  }

  genericComparator(objOne: any, objTwo: any): boolean {
    if (objTwo === null) {
      return true;
    }
    return objOne && objTwo && objOne.id === objTwo.id;
  }

  cloneValidationAcrossTestCases(validation: any) {
    const modalRef = this.modalService.open(CloneAcrossTestcaseComponent, {
      ariaLabelledBy: "modal-basic-title",
      backdrop: "static",
      windowClass: "confirm-modal",
      centered: true,
      size: "lg",
    });
    modalRef.componentInstance.validation = validation;
  }

  onActiveChange(event: any, obj) {
    this.onActiveChangeTriggered = true;
    obj.selected = true;
  }

  saveBulk() {
    this.validations.forEach((item) => {
      if (item.selected != undefined) delete item.selected;
    });

    let bulkValidations = this.validations.map((x) => Object.assign({}, x));

    bulkValidations.forEach((item) => {
      if (item.testDataSequence) {
        if (item.testDataSequence === constants.testDataPrimary) {
          item.testDataSequence = 0;
        } else {
          item.testDataSequence = item.testDataSequence.split(" ")[1];
        }
      }
    });

    this.testCaseService.saveBulkValidation(bulkValidations).subscribe((data) => {
      if (data.code == 200) {
        this.onActiveChangeTriggered = false;
        this.toastr.success(data.message);
        this.setDeleteAll = false;
        this.isAllValidationsSelected = false;
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  resetBulk() {
    this.getValidations();
    this.onActiveChangeTriggered = false;
  }

  trackByIndex(index: number, items) {
    return items.id;
  }

  onCheckboxChange(isChecked: boolean) {
    this.isFilter = isChecked;
    if (this.isFilter) {
      this.validations = this.validations.filter(validation =>
        validation.actual?.displayValue === 'response_body' &&
        (validation?.condition === "EQUAL" || validation?.condition === "NOT_EQUAL") &&
        validation.expected?.fileInfo?.fileName?.endsWith(".json")
      );
    } else {
      this.validations = [...this.schemaValidation];
    }
  }

}
